import React from 'react';
import Title from '../components/Title';
import TextBox from '../components/TextBox';
import TextBackground from '../components/TextBackground';
import Navbar from '../components/Navbar';
import ContactBox from '../components/ContactBox';
import './Home.css';

const Home = () => {
  return (
    <>
      <div className="page">
        <TextBackground />
        <div className="mobile-home-container">
          <Title />
          <Navbar />
          <TextBox />
        </div>
      </div>
      <ContactBox />
    </>
  );
};

export default Home;
